import { SubmissionPlacementTaskInfo } from '@common/types';
import { Chip } from '@common-components';
import { PlacementTask } from 'enums';
import { messages } from 'i18n';

interface PlacementTaskChipProps {
  task: SubmissionPlacementTaskInfo;
}

export function PlacementTaskChip({ task }: PlacementTaskChipProps) {
  return (
    <Chip
      label={messages.placementProcess.placementTasks[task.placementTask as PlacementTask]}
      size="small"
      variant="contained"
      color="secondary"
    />
  );
}
